var cell_default = {
  "cell": "-Zl2h",
  "header": "GKvzp",
  "selected": "YQoGA",
  "editing": "BLEcy",
  "singleSelection": "_7qn0t",
  "hideLastBlock": "rwRxe",
  "editorWrapper": "mnsOw",
  "viewerWrapper": "zv4DR",
  "hideFirstBlock": "cbGZb",
  "editor": "_65m4z",
  "edit": "ZF9qX",
  "view": "f4A3F",
  "editingToolbarWrapper": "CY8eR",
  "selectAll": "Qp4Aq",
  "disableSelection": "_2CdUs"
};
export {
  cell_default as default
};
//# sourceMappingURL=cell-scss.js.map
